export default "__VITE_ASSET__Dtjptfnz__"